// extracted by mini-css-extract-plugin
module.exports = {"root":"ForegroundItem_root__HcTYE","unfold":"ForegroundItem_unfold__iqWDZ"};